import {cookieConsent} from './helpers'

export default class Modal {
  constructor(node, index) {
    this.node = node
    this.index = index

    this.modalId = '#' + this.node.dataset.modalId
    this.modalWindow = document.querySelector(this.modalId)
    this.modalCloseButton = this.modalWindow.querySelector('.modal-close')

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.manageFocus = this.manageFocus.bind(this)

    this.body = document.querySelector('html')

    this.videoId = this.node.dataset.videoId
    this.iframe = this.modalWindow.querySelector('iframe')

    this.init()
  }

  init() {
    console.debug('  -> Modal init')
    this.addListeners()
  }

  addListeners() {
    this.node.addEventListener('click', this.openModal)
    this.node.addEventListener('keydown', (e) => {
      if( e.key === 'Enter' ) {
        this.openModal(e)
      }
    })
    this.modalCloseButton.addEventListener('click', this.closeModal)
    this.modalCloseButton.addEventListener('keydown', (e) => {
      if( e.key === 'Enter' ) {
        this.closeModal(e)
      }
    })
  }

  manageFocus(e) {
    const focusableSelectors = [
      'a[href]',
      'button',
      'textarea',
      'input[type="text"]',
      'input[type="radio"]',
      'input[type="checkbox"]',
      'select',
      '[tabindex]:not([tabindex="-1"])',
    ]
  
    const focusableElements = Array.from(
      this.modalWindow.querySelectorAll(focusableSelectors.join(', '))
    )
  
    if( focusableElements.length === 0 ) return
  
    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]
  
    // Focus trap management for Tab e Shift+Tab keypress
    if( e.key === 'Tab' ) {
      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault()
        lastElement.focus()
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault()
        firstElement.focus()
      }
    }
  }

  openModal(e) {
    e.preventDefault()
    console.log('cookieConsent', cookieConsent())
    console.log('videoId', this.videoId)
    if( this.videoId && !cookieConsent() ){
      window.open(`https://www.youtube.com/watch?v=${this.videoId}`, '_blank')
    } else {
      this.setvideoUrl()
      this.modalWindow.style.display = 'block'
      setTimeout(() => {
        this.node.setAttribute('aria-expanded', 'true')
        this.body.classList.add('h-noscroll')
        this.modalWindow.classList.add('open')
        if( this.node.id ){
          this.modalWindow.setAttribute('aria-labelledby', this.node.id)
          this.modalWindow.setAttribute('aria-describedby', this.node.id)
        }
        // Setting aria-label attribute for iframe
        const iframe = this.modalWindow.querySelector('iframe')
        if( iframe ){
          iframe.setAttribute('aria-label', `Player video id: ${this.videoId}`)
        }
        // Setting focus to first element and trapping focus into modal until closed
        const focusableSelectors = [
          'a[href]',
          'button',
          'textarea',
          'input[type="text"]',
          'input[type="radio"]',
          'input[type="checkbox"]',
          'select',
          '[tabindex]:not([tabindex="-1"])',
        ]
        const focusableElements = Array.from(
          this.modalWindow.querySelectorAll(focusableSelectors.join(', '))
        )
        if (focusableElements.length > 0) {
          focusableElements[0].focus()
        }
        document.addEventListener('keydown', this.manageFocus)
      }, 50);
    }
  }

  closeModal(e) {
    e.preventDefault()
    this.node.setAttribute('aria-expanded', 'false')
    this.modalWindow.classList.remove('open')
    this.body.classList.remove('h-noscroll')
  
    // Remove event listener
    document.removeEventListener('keydown', this.manageFocus)
  
    setTimeout(() => {
      this.modalWindow.style.display = 'none'
    }, 500)
    this.unsetVideoUrl()
  }

  setvideoUrl() {
    if( !this.iframe || !this.videoId ) return
    this.iframe.setAttribute('src', `https://www.youtube.com/embed/${this.videoId}`)
  }

  unsetVideoUrl() {
    if (!this.iframe) return
    this.iframe.setAttribute('src', '')
  }

  destroy() {
    console.debug('  -> Modal destroy', this.node)

    this.openModal.removeEventListener('click', this.openModal)
    this.closeModal.removeEventListener('click', this.closeModal)
  }

  static destroyAll() {
    console.debug('  -> Modal destroy all')
    Modal.items.forEach((elem) => {
      elem.destroy()
    })
  }

  static init() {
    console.debug('== Modal components ==')

    Modal.items = Array.from(document.querySelectorAll('[data-modal-id]')).map(
      (node, index) => new Modal(node, index)
    )
  }
}
